import React from 'react';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

import { VERSIONING_SECTION_IDS } from '../constants';

type Props = {
  sectionId: ID;
};

function LifecycleDocLink({ sectionId }: Props) {
  const baseURL = `${BASE_DOC_URL_VB}/manage/`;
  const { title, url } = {
    [VERSIONING_SECTION_IDS.PROMOTE]: {
      title: 'version promotion guide',
      url: `${baseURL}promote`,
    },
    [VERSIONING_SECTION_IDS.MIGRATE]: {
      title: 'version migration guide',
      url: `${baseURL}migrate`,
    },
  }[sectionId];

  return (
    <Link href={url} target="_blank">
      {title}
    </Link>
  );
}

export default LifecycleDocLink;
